<template>
  <div class="material-comments">
    <el-form inline label-width="66px" @submit.native.prevent class="filter-form elementui-common-form-styles" v-highlight>
      <el-form-item label="素材">
        <el-input v-model="form.imageNames" clearable style="width: 180px" placeholder="输入素材名称查询">
          <el-button slot="append" icon="el-icon-search" @click="queryAction"></el-button>
        </el-input>
      </el-form-item>

      <el-form-item label="计划账号">
        <el-select v-model="form.accountIdList" clearable filterable multiple collapse-tags style="width: 180px" placeholder="全部">
          <el-option v-for="item in mediaAccouts" :key="item.id" :label="item.name" :value="item.id"> </el-option>
        </el-select>
      </el-form-item>

      <el-form-item label="评论类型">
        <el-select v-model="form.commentTypeList" clearable multiple collapse-tags style="width: 180px" placeholder="全部">
          <el-option v-for="item in COMMENT_TYPES" :key="item.id" :label="item.name" :value="item.id"> </el-option>
        </el-select>
      </el-form-item>

      <el-form-item label="隐藏状态">
        <el-select v-model="form.hideStatusList" multiple collapse-tags clearable style="width: 180px" placeholder="全部">
          <el-option v-for="item in VISIBLE_TYPES" :key="item.id" :label="item.name" :value="item.id"> </el-option>
        </el-select>
      </el-form-item>

      <el-form-item label="回复状态">
        <el-select v-model="form.replyStatusList" multiple collapse-tags clearable style="width: 180px" placeholder="全部">
          <el-option v-for="item in REPLY_TYPES" :key="item.id" :label="item.name" :value="item.id"> </el-option>
        </el-select>
      </el-form-item>

      <el-form-item label="管理人员">
        <ThrottleSelector
          style="width: 180px"
          v-model="form.launchOpIds"
          multiple
          collapse-tags
          :list="sysUsers"
          placeholder="全部"
          filterable
          clearable
        />
      </el-form-item>

      <el-form-item label="统计时间">
        <DateRangePicker v-model="form.datetime" :clearable="false" style="width: 220px"></DateRangePicker>
      </el-form-item>

      <el-form-item class="bg-transparent">
        <el-button type="primary" :loading="tableLoading" @click="initQueryAction">查询</el-button>
      </el-form-item>
    </el-form>
    <div class="data-summary">
      <span>可见评论数：{{ summryData.showNum }}</span>
      <span>可见负评论数：{{ summryData.negativeNum }}</span>
      <span>
        <span>可见负评论负评率：</span>
        <span v-if="summryData.negativeRate">{{ (summryData.negativeRate * 100).toFixed(2) }}%</span>
        <span v-else>0%</span>
      </span>
    </div>
    <div class="operation-btns">
      <el-button @click="onBatchReplyComments()">批量回复</el-button>
      <el-button @click="onBatchHideComments()">批量隐藏</el-button>
    </div>

    <Viewport v-model="tableHeight">
      <el-table
        v-loading="tableLoading"
        class="common-el-table-styles summary-el-table-styles"
        ref="table"
        border
        stripe
        :height="tableHeight"
        :data="tableData"
        @selection-change="onSelectionChange"
      >
        <el-table-column type="selection" width="50"></el-table-column>
        <el-table-column fixed="left" label="评论内容" show-overflow-tooltip>
          <template slot-scope="{ row }">
            <div>
              <el-popover
                popper-class="comment-thumb-img-popover"
                v-for="(img, index) in row.images"
                :key="index"
                placement="top-start"
                trigger="click"
              >
                <el-avatar shape="square" :size="80" fit="cover" :src="img"></el-avatar>
                <el-button type="text" slot="reference"> <em class="el-icon-picture"></em> 图片</el-button>
              </el-popover>
              <span>{{ row.commentText }}</span>
            </div>
          </template>
        </el-table-column>
        <el-table-column fixed="left" label="操作" width="150">
          <template slot-scope="{ row }">
            <div v-if="row.permission === 2">
              <el-button type="text" @click="onCommentReply(row)">回复</el-button>
              <el-button type="text" @click="onCommentHide(row)">隐藏</el-button>
              <el-button type="text" @click="onCommentSetTop(row, true)" v-if="row.stickStatus === 0">置顶</el-button>
              <el-button type="text" @click="onCommentSetTop(row, false)" v-else>取消置顶</el-button>
            </div>
          </template>
        </el-table-column>
        <el-table-column prop="commentTypeText" label="评论类型" width="70"></el-table-column>
        <el-table-column prop="commentReplyStatusText" label="回复状态" width="70"></el-table-column>
        <el-table-column prop="commentVisibleStatusText" label="隐藏状态" width="70"></el-table-column>
        <el-table-column prop="commentLevelText" label="评论层级" width="70"></el-table-column>
        <el-table-column prop="awemeName" label="评论用户" show-overflow-tooltip width="90"></el-table-column>
        <el-table-column prop="formatedCreateTime" label="评论时间" width="150"></el-table-column>
        <el-table-column prop="replyCount" label="相关回复数" width="80"></el-table-column>
        <el-table-column prop="likeCount" label="点赞数" width="70"></el-table-column>
        <el-table-column prop="adName" label="视频标题"></el-table-column>
        <el-table-column prop="imageName" label="素材名称" show-overflow-tooltip width="120"></el-table-column>
        <el-table-column prop="mediaMaterialId" label="媒体素材ID" width="160"></el-table-column>
        <el-table-column prop="adAccount" label="计划账号" width="140"></el-table-column>
      </el-table>

      <el-pagination
        class="pager"
        background
        layout="sizes, prev, pager, next"
        :page-size.sync="pager.pageSize"
        :current-page.sync="pager.pageIndex"
        :total="pager.total"
        @current-change="queryAction"
      >
      </el-pagination>
    </Viewport>

    <el-dialog title="回复评论" :visible.sync="replyCommentsDialogVisible" width="420px">
      <el-input v-model="replyComments" type="textarea" :rows="7" placeholder="请输入回复内容"></el-input>
      <span slot="footer" class="dialog-footer">
        <el-button @click="onReplyCommentCancel">取 消</el-button>
        <el-button type="primary" @click="onReplyCommentConfirm">确 定</el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script setup>
import { ref, computed, onActivated, nextTick } from 'vue'
import { useRoute, useRouter } from 'vue-router/composables'
import { useCommentQueryForm, useCommentTable } from './hooks/useMaterialComments.js'
import { MEDIAS, SYS_USERS, MEDIA_ACCOUNTS, initPageData } from '@/data/global-opts'
import { COMMENT_TYPES, VISIBLE_TYPES, REPLY_TYPES } from './data/material-comments-const.js'
import DateRangePicker from '@/components/date-range-picker/index.vue'
import ThrottleSelector from '@/components/throttle-select/index.vue'
const PAGE_REQUIRED_OPTS = initPageData([SYS_USERS, MEDIA_ACCOUNTS])
const sysUsers = computed(PAGE_REQUIRED_OPTS.SYS_USERS)
const mediaAccouts = computed(PAGE_REQUIRED_OPTS.MEDIA_ACCOUNTS)
const route = useRoute()
const { form, summryData, tableLoading, queryAction } = useCommentQueryForm(route)

const {
  pager,
  tableData,
  replyComments,
  replyCommentsDialogVisible,
  onSelectionChange,
  onCommentReply,
  onCommentHide,
  onCommentSetTop,
  onBatchHideComments,
  onBatchReplyComments,
  onReplyCommentConfirm,
  onReplyCommentCancel
} = useCommentTable(queryAction)

const tableHeight = ref(330)

function initQueryAction() {
  pager.value.pageIndex = 1
  queryAction()
}

queryAction()
onActivated(() => {
  const newNames = route.query.imageName ? decodeURIComponent(route.query.imageName) : ''
  if (form.value.imageNames !== newNames) {
    form.value.imageNames = newNames
    queryAction()
  }
})
</script>

<style lang="scss" scoped>
.filter-form {
  padding-top: 10px;
}
.data-summary {
  display: flex;
  align-items: center;
  font-size: 14px;
  > span {
    margin-right: 20px;
  }
}
.operation-btns {
  padding: 6px 0;
}
.pager {
  text-align: right;
  padding: 10px 0;
}
</style>
<style lang="scss">
.comment-thumb-img-popover {
  min-width: 108px !important;
}
</style>
